import type { TContactParam } from '@cian/newbuilding-chat-component';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IBuilderChatState } from '../../types/builderChat';

const initialState: IBuilderChatState = {
  isOpened: false,
};

export const builderChatSlice = createSlice({
  name: 'builderChat',
  initialState,
  reducers: {
    openBuilderChat: (state, action: PayloadAction<TContactParam>) => {
      state.isOpened = true;
      state.chatContact = action.payload;
    },
    closeBuilderChat: state => {
      state.isOpened = false;
      state.chatContact = undefined;
    },
    setBuilderChatButtonClicked: state => {
      state.isButtonClicked = true;
    },
  },
});

export const {
  reducer: builderChatReducer,
  actions: { openBuilderChat, closeBuilderChat, setBuilderChatButtonClicked },
} = builderChatSlice;
